import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.20676 0.75C4.02515 0.75002 3.85098 0.829044 3.72256 0.969692C3.59414 1.11034 3.52199 1.30109 3.52197 1.5V13.5C3.52199 13.6989 3.59414 13.8897 3.72256 14.0303C3.85098 14.171 4.02515 14.25 4.20676 14.25H16.5328C16.7145 14.25 16.8886 14.171 17.017 14.0303C17.1455 13.8897 17.2176 13.6989 17.2176 13.5V4.5C17.2176 4.30109 17.1455 4.11034 17.017 3.96969C16.8886 3.82904 16.7145 3.75002 16.5328 3.75H10.2922L8.90793 1.125C8.84787 1.01108 8.76151 0.916466 8.65752 0.850646C8.55353 0.784826 8.43556 0.750116 8.31545 0.75H4.20676Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1.4675 3.75C1.08929 3.75 0.782715 4.08579 0.782715 4.5V16.5C0.782783 16.9142 1.08929 17.25 1.4675 17.25H13.7936C13.9752 17.25 14.1494 17.171 14.2778 17.0303C14.4062 16.8897 14.4784 16.6989 14.4784 16.5C14.4784 16.3011 14.4062 16.1103 14.2778 15.9697C14.1494 15.829 13.9752 15.75 13.7936 15.75H2.15228V4.5C2.15228 4.08579 1.8457 3.75 1.4675 3.75Z",
		fill: "currentColor"
	})]
});
export default SvgFolder;
